{
    "PreviewHeader": "Prévisualisation",
    "PreviewValueInvalid": "[Format non valide]",
    "NAME": "Preview"
}